import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
};

export type Capability = {
  __typename?: 'Capability';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  messageTemplateFields: Array<TemplateField>;
  settingsTemplateFields: Array<TemplateField>;
};

export type Category = {
  __typename?: 'Category';
  checksum?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  illustration: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type CategoryInput = {
  description: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  illustration: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Company = {
  __typename?: 'Company';
  config: CompanyConfig;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CompanyConfig = {
  __typename?: 'CompanyConfig';
  defaultGatewayId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facts?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  primaryBrandColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  primaryColorText?: Maybe<Scalars['String']['output']>;
  secondaryBrandColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type CompanyConfigInput = {
  defaultGatewayId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facts?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  primaryBrandColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColorText?: InputMaybe<Scalars['String']['input']>;
  secondaryBrandColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInput = {
  config: CompanyConfigInput;
  name: Scalars['String']['input'];
};

export type CreateTaskDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  capabilityId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  illustration: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateTaskInput = {
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  taskDefinitionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaskMessageInput = {
  formValues: Scalars['JSON']['input'];
};

export type Favorite = {
  __typename?: 'Favorite';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  taskDefinitionId?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type FavoriteInput = {
  taskDefinitionId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type FavoriteList = {
  __typename?: 'FavoriteList';
  items: Array<FavoriteListItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type FavoriteListItem = {
  __typename?: 'FavoriteListItem';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  task?: Maybe<Task>;
  taskDefinition?: Maybe<TaskDefinition>;
  taskDefinitionId?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export enum FieldDefinitionType {
  BOOLEAN = 'BOOLEAN',
  FILE = 'FILE',
  FILES = 'FILES',
  KNOWLEDGE_BASE_IDS = 'KNOWLEDGE_BASE_IDS',
  NUMBER = 'NUMBER',
  OPTIONS = 'OPTIONS',
  STRING = 'STRING'
}

export type File = {
  __typename?: 'File';
  contentType?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  smallUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FileUploadInfo = {
  __typename?: 'FileUploadInfo';
  fields: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type FollowUpPrompt = {
  __typename?: 'FollowUpPrompt';
  label: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type FollowUpPromptInput = {
  label: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type FormFieldDefinition = {
  __typename?: 'FormFieldDefinition';
  default?: Maybe<Scalars['Any']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<FormFieldDefinitionOption>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type FormFieldDefinitionInput = {
  default?: InputMaybe<Scalars['Any']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<FormFieldDefinitionOptionInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tooltip?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type FormFieldDefinitionOption = {
  __typename?: 'FormFieldDefinitionOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FormFieldDefinitionOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FormFieldOption = {
  __typename?: 'FormFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Gateway = {
  __typename?: 'Gateway';
  configFields: Array<TemplateField>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GatewayConfig = {
  __typename?: 'GatewayConfig';
  companyId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  gatewayId: Scalars['String']['output'];
};

export type GatewayConfigInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
};

export type InstanceConfig = {
  __typename?: 'InstanceConfig';
  defaultGatewayId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  primaryColorText?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type InstanceConfigInput = {
  defaultGatewayId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColorText?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Role;
};

export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  accessType: KnowledgeBaseAccessType;
  companyId: Scalars['String']['output'];
  hiddenByDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: KnowledgeBaseType;
};

export enum KnowledgeBaseAccessType {
  ALL = 'ALL',
  USER_LIST = 'USER_LIST'
}

export type KnowledgeBaseDirectory = {
  __typename?: 'KnowledgeBaseDirectory';
  fileUploadInfo: FileUploadInfo;
  files?: Maybe<Array<KnowledgeBaseFile>>;
  folders?: Maybe<Array<Folder>>;
};

export type KnowledgeBaseFile = {
  __typename?: 'KnowledgeBaseFile';
  contentType?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseInput = {
  accessType: KnowledgeBaseAccessType;
  hiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: KnowledgeBaseType;
};

export enum KnowledgeBaseType {
  EXTERNAL = 'EXTERNAL',
  FILES = 'FILES'
}

export type ListOptions = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ListOrder>;
  startingToken?: InputMaybe<Scalars['String']['input']>;
};

export enum ListOrder {
  asc = 'asc',
  desc = 'desc'
}

export type Migration = {
  __typename?: 'Migration';
  id: Scalars['String']['output'];
  runAt: Scalars['DateTime']['output'];
};

export type Module = {
  __typename?: 'Module';
  categories?: Maybe<Array<Category>>;
  checksum?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  illustration: Scalars['String']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type ModuleInput = {
  description: Scalars['String']['input'];
  illustration: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addFavorite: Favorite;
  createCategory: Category;
  createCompany: Company;
  createCompanyFileUpload: FileUploadInfo;
  createGatewayConfig: GatewayConfig;
  createKnowledgeBase: KnowledgeBase;
  createKnowledgeBaseFolder: Scalars['Boolean']['output'];
  createModule: Module;
  createTask: Task;
  createTaskDefinition: TaskDefinition;
  deleteCategory: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteCompanyFile: Scalars['Boolean']['output'];
  deleteGatewayConfig: Scalars['Boolean']['output'];
  deleteKnowledgeBase: Scalars['Boolean']['output'];
  deleteKnowledgeBaseFile: Scalars['Boolean']['output'];
  deleteModule: Scalars['Boolean']['output'];
  deleteTask: Scalars['Boolean']['output'];
  deleteTaskDefinition: Scalars['Boolean']['output'];
  deleteTaskDefinitionFile: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableUser: Scalars['Boolean']['output'];
  enableUser: Scalars['Boolean']['output'];
  inviteUser: User;
  removeFavorite: Scalars['Boolean']['output'];
  runMigrations: Scalars['Boolean']['output'];
  setInstanceConfig: InstanceConfig;
  updateCategory: Category;
  updateCompany: Company;
  updateGatewayConfig: GatewayConfig;
  updateKnowledgeBase: KnowledgeBase;
  updateModule: Module;
  updateTask: Task;
  updateTaskDefinition: TaskDefinition;
  updateTaskDefinitionSettings: TaskDefinitionSettings;
  updateUser: User;
};


export type MutationAddFavoriteArgs = {
  dto: FavoriteInput;
};


export type MutationCreateCategoryArgs = {
  dto: CategoryInput;
};


export type MutationCreateCompanyArgs = {
  dto: CompanyInput;
};


export type MutationCreateGatewayConfigArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  dto: GatewayConfigInput;
  gatewayId: Scalars['String']['input'];
};


export type MutationCreateKnowledgeBaseArgs = {
  dto: KnowledgeBaseInput;
};


export type MutationCreateKnowledgeBaseFolderArgs = {
  knowledgeBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateModuleArgs = {
  dto: ModuleInput;
};


export type MutationCreateTaskArgs = {
  dto: CreateTaskInput;
};


export type MutationCreateTaskDefinitionArgs = {
  dto: CreateTaskDefinitionInput;
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCompanyFileArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationDeleteGatewayConfigArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  gatewayId: Scalars['String']['input'];
};


export type MutationDeleteKnowledgeBaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteKnowledgeBaseFileArgs = {
  id: Scalars['String']['input'];
  knowledgeBaseId: Scalars['String']['input'];
};


export type MutationDeleteModuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTaskDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTaskDefinitionFileArgs = {
  fileId: Scalars['String']['input'];
  taskDefinitionId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDisableUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationEnableUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationInviteUserArgs = {
  dto: InviteUserInput;
};


export type MutationRemoveFavoriteArgs = {
  dto: FavoriteInput;
};


export type MutationSetInstanceConfigArgs = {
  config: InstanceConfigInput;
};


export type MutationUpdateCategoryArgs = {
  dto: CategoryInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCompanyArgs = {
  dto: CompanyInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateGatewayConfigArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  dto: GatewayConfigInput;
  gatewayId: Scalars['String']['input'];
};


export type MutationUpdateKnowledgeBaseArgs = {
  dto: KnowledgeBaseInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateModuleArgs = {
  dto: ModuleInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  dto: UpdateTaskInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTaskDefinitionArgs = {
  dto: UpdateTaskDefinitionInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTaskDefinitionSettingsArgs = {
  dto: TaskDefinitionSettingsInput;
  taskDefinitionId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  dto: UpdateUserInput;
  id: Scalars['String']['input'];
};

export type Provider = {
  __typename?: 'Provider';
  capabilityId: Scalars['String']['output'];
  gatewayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  capabilities: Array<Capability>;
  capabilityForTask?: Maybe<Capability>;
  categories: Array<Category>;
  category: Category;
  companies: Array<Company>;
  companyFiles: Array<File>;
  favorites: FavoriteList;
  gatewayConfigs: Array<GatewayConfig>;
  gateways: Array<Gateway>;
  instanceConfig: InstanceConfig;
  knowledgeBase: KnowledgeBase;
  knowledgeBaseDirectory: KnowledgeBaseDirectory;
  knowledgeBases: Array<KnowledgeBase>;
  module: Module;
  modules: Array<Module>;
  modulesForCompany: Array<Module>;
  modulesWithCategories: Array<Module>;
  myKnowledgeBases: Array<KnowledgeBase>;
  ownCompany: Company;
  ownUser: User;
  task: Task;
  taskDefinition: TaskDefinition;
  taskDefinitionFiles?: Maybe<Array<File>>;
  taskDefinitionForTask?: Maybe<TaskDefinition>;
  taskDefinitionSettings: TaskDefinitionSettings;
  taskDefinitions: Array<TaskDefinition>;
  taskDefinitionsForCompany: Array<TaskDefinition>;
  taskDefinitionsSearch: Array<TaskDefinition>;
  taskMessages: Array<TaskMessage>;
  tasks: TaskList;
  users: UserList;
};


export type QueryCapabilityForTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  moduleId: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryFavoritesArgs = {
  options?: InputMaybe<ListOptions>;
};


export type QueryGatewayConfigsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeBaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryKnowledgeBaseDirectoryArgs = {
  knowledgeBaseId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskDefinitionFilesArgs = {
  taskDefinitionId: Scalars['String']['input'];
};


export type QueryTaskDefinitionForTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryTaskDefinitionSettingsArgs = {
  taskDefinitionId: Scalars['String']['input'];
};


export type QueryTaskDefinitionsArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryTaskDefinitionsForCompanyArgs = {
  moduleId: Scalars['String']['input'];
};


export type QueryTaskDefinitionsSearchArgs = {
  options: TaskDefinitionsSearchInput;
};


export type QueryTaskMessagesArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryTasksArgs = {
  options?: InputMaybe<ListOptions>;
};


export type QueryUsersArgs = {
  options?: InputMaybe<ListOptions>;
};

export type RagDocumentReference = {
  __typename?: 'RagDocumentReference';
  content?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pageNumber?: Maybe<Scalars['Int']['output']>;
  relevance?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  USER = 'USER'
}

export type Task = {
  __typename?: 'Task';
  capabilityId: Scalars['String']['output'];
  categoryId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileUploadInfo?: Maybe<FileUploadInfo>;
  followUpPrompts?: Maybe<Array<FollowUpPrompt>>;
  gatewayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<TaskMessage>>;
  summary?: Maybe<Scalars['String']['output']>;
  taskDefinitionId?: Maybe<Scalars['String']['output']>;
  taskDefinitionLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type TaskDefinition = {
  __typename?: 'TaskDefinition';
  active?: Maybe<Scalars['Boolean']['output']>;
  capability?: Maybe<Capability>;
  capabilityId: Scalars['String']['output'];
  categoryId: Scalars['String']['output'];
  checksum?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  fileUploadInfo?: Maybe<FileUploadInfo>;
  followUpPrompts?: Maybe<Array<FollowUpPrompt>>;
  formDefinition?: Maybe<Array<FormFieldDefinition>>;
  id: Scalars['String']['output'];
  illustration: Scalars['String']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  messageTemplate?: Maybe<Scalars['JSON']['output']>;
  moduleId: Scalars['String']['output'];
  searchVector?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  settingsFormDefinition?: Maybe<Array<FormFieldDefinition>>;
  settingsTemplate?: Maybe<Scalars['JSON']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  usableProviders?: Maybe<Array<Provider>>;
};

export type TaskDefinitionSettings = {
  __typename?: 'TaskDefinitionSettings';
  companyId: Scalars['String']['output'];
  fileUploadInfo?: Maybe<FileUploadInfo>;
  settings: Scalars['JSON']['output'];
  taskDefinitionId: Scalars['String']['output'];
};

export type TaskDefinitionSettingsInput = {
  settings: Scalars['JSON']['input'];
};

export type TaskDefinitionStorage = {
  __typename?: 'TaskDefinitionStorage';
  companyId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  storage: Scalars['JSON']['output'];
  taskDefinitionId: Scalars['String']['output'];
};

export type TaskDefinitionsSearchFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type TaskDefinitionsSearchInput = {
  term: Scalars['String']['input'];
  where?: InputMaybe<TaskDefinitionsSearchFilterInput>;
};

export type TaskList = {
  __typename?: 'TaskList';
  items: Array<Task>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type TaskMessage = {
  __typename?: 'TaskMessage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  input: TaskMessageInput;
  message?: Maybe<Scalars['JSON']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<TaskMessageResponse>;
};

export type TaskMessageInput = {
  __typename?: 'TaskMessageInput';
  followUpPrompt?: Maybe<FollowUpPrompt>;
  formValues?: Maybe<Scalars['JSON']['output']>;
  prompt?: Maybe<Scalars['JSON']['output']>;
};

export type TaskMessageResponse = {
  __typename?: 'TaskMessageResponse';
  files?: Maybe<Array<Maybe<File>>>;
  ragDocumentReferences?: Maybe<Array<RagDocumentReference>>;
  sources?: Maybe<Array<TaskMessageResponseSource>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TaskMessageResponseSource = {
  __typename?: 'TaskMessageResponseSource';
  content?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: TaskMessageResponseSourceType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum TaskMessageResponseSourceType {
  KNOWLEDGE_BASE_FILE = 'KNOWLEDGE_BASE_FILE',
  URL = 'URL'
}

export type TaskStorage = {
  __typename?: 'TaskStorage';
  companyId: Scalars['String']['output'];
  storage: Scalars['JSON']['output'];
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TemplateField = {
  __typename?: 'TemplateField';
  default?: Maybe<Scalars['Any']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<TemplateFieldOption>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<TemplateFieldRole>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TemplateFieldOption = {
  __typename?: 'TemplateFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum TemplateFieldRole {
  FILES = 'FILES',
  IMAGES = 'IMAGES',
  KNOWLEDGE_BASE_IDS = 'KNOWLEDGE_BASE_IDS',
  PROMPT = 'PROMPT'
}

export type UpdateTaskDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  capabilityId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  followUpPrompts?: InputMaybe<Array<FollowUpPromptInput>>;
  formDefinition?: InputMaybe<Array<FormFieldDefinitionInput>>;
  illustration?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  messageTemplate?: InputMaybe<Scalars['JSON']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
  settingsFormDefinition?: InputMaybe<Array<FormFieldDefinitionInput>>;
  settingsTemplate?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskInput = {
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
};

export type User = {
  __typename?: 'User';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  knowledgeBaseIds?: Maybe<Array<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  status?: Maybe<UserStatus>;
  sub: Scalars['String']['output'];
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum UserStatus {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export type CapabilityFragment = { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, role?: TemplateFieldRole | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }> };

export type GetCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCapabilitiesQuery = { __typename?: 'Query', capabilities: Array<{ __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, role?: TemplateFieldRole | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }> }> };

export type CategoryFragment = { __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string };

export type CreateCategoryMutationVariables = Exact<{
  dto: CategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string } };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: boolean };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string } };

export type GetCategoriesQueryVariables = Exact<{
  moduleId: Scalars['String']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string }> };

export type CompanyFragment = { __typename?: 'Company', id: string, name: string, config: { __typename?: 'CompanyConfig', description?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, primaryBrandColor?: string | null, secondaryBrandColor?: string | null, facts?: string | null, defaultGatewayId?: string | null } };

export type CreateCompanyMutationVariables = Exact<{
  dto: CompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string, name: string, config: { __typename?: 'CompanyConfig', description?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, primaryBrandColor?: string | null, secondaryBrandColor?: string | null, facts?: string | null, defaultGatewayId?: string | null } } };

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: CompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, name: string, config: { __typename?: 'CompanyConfig', description?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, primaryBrandColor?: string | null, secondaryBrandColor?: string | null, facts?: string | null, defaultGatewayId?: string | null } } };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: string, name: string, config: { __typename?: 'CompanyConfig', description?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, primaryBrandColor?: string | null, secondaryBrandColor?: string | null, facts?: string | null, defaultGatewayId?: string | null } }> };

export type GetOwnCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnCompanyQuery = { __typename?: 'Query', ownCompany: { __typename?: 'Company', id: string, name: string, config: { __typename?: 'CompanyConfig', description?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, primaryBrandColor?: string | null, secondaryBrandColor?: string | null, facts?: string | null, defaultGatewayId?: string | null } } };

export type FavoriteFragment = { __typename?: 'Favorite', companyId: string, createdAt: Date, taskDefinitionId?: string | null, taskId?: string | null, userId: string };

export type FavoriteListItemFragment = { __typename?: 'FavoriteListItem', companyId: string, createdAt: Date, taskDefinitionId?: string | null, taskId?: string | null, userId: string, task?: { __typename?: 'Task', id: string, isFavorite?: boolean | null, taskDefinitionLabel?: string | null, summary?: string | null } | null, taskDefinition?: { __typename?: 'TaskDefinition', id: string, title: string, description: string, illustration: string, isFavorite?: boolean | null, capabilityId: string, categoryId: string, moduleId: string, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string }> | null } | null };

export type AddFavoriteMutationVariables = Exact<{
  dto: FavoriteInput;
}>;


export type AddFavoriteMutation = { __typename?: 'Mutation', addFavorite: { __typename?: 'Favorite', companyId: string, createdAt: Date, taskDefinitionId?: string | null, taskId?: string | null, userId: string } };

export type RemoveFavoriteMutationVariables = Exact<{
  dto: FavoriteInput;
}>;


export type RemoveFavoriteMutation = { __typename?: 'Mutation', removeFavorite: boolean };

export type GetFavoritesQueryVariables = Exact<{
  options?: InputMaybe<ListOptions>;
}>;


export type GetFavoritesQuery = { __typename?: 'Query', favorites: { __typename?: 'FavoriteList', nextToken?: string | null, items: Array<{ __typename?: 'FavoriteListItem', companyId: string, createdAt: Date, taskDefinitionId?: string | null, taskId?: string | null, userId: string, task?: { __typename?: 'Task', id: string, isFavorite?: boolean | null, taskDefinitionLabel?: string | null, summary?: string | null } | null, taskDefinition?: { __typename?: 'TaskDefinition', id: string, title: string, description: string, illustration: string, isFavorite?: boolean | null, capabilityId: string, categoryId: string, moduleId: string, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string }> | null } | null }> } };

export type GatewayConfigFragment = { __typename?: 'GatewayConfig', companyId?: string | null, config?: any | null, gatewayId: string };

export type CreateGatewayConfigMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  dto: GatewayConfigInput;
}>;


export type CreateGatewayConfigMutation = { __typename?: 'Mutation', createGatewayConfig: { __typename?: 'GatewayConfig', companyId?: string | null, config?: any | null, gatewayId: string } };

export type DeleteGatewayConfigMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteGatewayConfigMutation = { __typename?: 'Mutation', deleteGatewayConfig: boolean };

export type UpdateGatewayConfigMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  dto: GatewayConfigInput;
}>;


export type UpdateGatewayConfigMutation = { __typename?: 'Mutation', updateGatewayConfig: { __typename?: 'GatewayConfig', companyId?: string | null, config?: any | null, gatewayId: string } };

export type GetGatewayConfigsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGatewayConfigsQuery = { __typename?: 'Query', gatewayConfigs: Array<{ __typename?: 'GatewayConfig', companyId?: string | null, config?: any | null, gatewayId: string }> };

export type GatewayFragment = { __typename?: 'Gateway', id: string, label: string, configFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }> };

export type GetGatewaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGatewaysQuery = { __typename?: 'Query', gateways: Array<{ __typename?: 'Gateway', id: string, label: string, configFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }> }> };

export type InstanceConfigFragment = { __typename?: 'InstanceConfig', name?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, defaultGatewayId?: string | null };

export type SetInstanceConfigMutationVariables = Exact<{
  config: InstanceConfigInput;
}>;


export type SetInstanceConfigMutation = { __typename?: 'Mutation', setInstanceConfig: { __typename?: 'InstanceConfig', name?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, defaultGatewayId?: string | null } };

export type GetInstanceConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstanceConfigQuery = { __typename?: 'Query', instanceConfig: { __typename?: 'InstanceConfig', name?: string | null, logo?: string | null, primaryColor?: string | null, primaryColorText?: string | null, secondaryColor?: string | null, defaultGatewayId?: string | null } };

export type KnowledgeBaseFragment = { __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null };

export type KnowledgeBaseDirectoryFragment = { __typename?: 'KnowledgeBaseDirectory', files?: Array<{ __typename?: 'KnowledgeBaseFile', id: string, fileName: string, contentType?: string | null, size?: number | null, url: string, processed: boolean }> | null, folders?: Array<{ __typename?: 'Folder', id: string, name: string, path: string }> | null, fileUploadInfo: { __typename?: 'FileUploadInfo', url: string, fields: any } };

export type CreateKnowledgeBaseMutationVariables = Exact<{
  dto: KnowledgeBaseInput;
}>;


export type CreateKnowledgeBaseMutation = { __typename?: 'Mutation', createKnowledgeBase: { __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null } };

export type CreateKnowledgeBaseFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}>;


export type CreateKnowledgeBaseFolderMutation = { __typename?: 'Mutation', createKnowledgeBaseFolder: boolean };

export type DeleteKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteKnowledgeBaseMutation = { __typename?: 'Mutation', deleteKnowledgeBase: boolean };

export type DeleteKnowledgeBaseFileMutationVariables = Exact<{
  knowledgeBaseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type DeleteKnowledgeBaseFileMutation = { __typename?: 'Mutation', deleteKnowledgeBaseFile: boolean };

export type UpdateKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: KnowledgeBaseInput;
}>;


export type UpdateKnowledgeBaseMutation = { __typename?: 'Mutation', updateKnowledgeBase: { __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null } };

export type KnowledgeBaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type KnowledgeBaseQuery = { __typename?: 'Query', knowledgeBase: { __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null } };

export type KnowledgeBaseDirectoryQueryVariables = Exact<{
  knowledgeBaseId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
}>;


export type KnowledgeBaseDirectoryQuery = { __typename?: 'Query', knowledgeBase: { __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null }, knowledgeBaseDirectory: { __typename?: 'KnowledgeBaseDirectory', files?: Array<{ __typename?: 'KnowledgeBaseFile', id: string, fileName: string, contentType?: string | null, size?: number | null, url: string, processed: boolean }> | null, folders?: Array<{ __typename?: 'Folder', id: string, name: string, path: string }> | null, fileUploadInfo: { __typename?: 'FileUploadInfo', url: string, fields: any } } };

export type KnowledgeBasesQueryVariables = Exact<{ [key: string]: never; }>;


export type KnowledgeBasesQuery = { __typename?: 'Query', knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null }> };

export type MyKnowledgeBasesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyKnowledgeBasesQuery = { __typename?: 'Query', myKnowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, type: KnowledgeBaseType, name: string, accessType: KnowledgeBaseAccessType, companyId: string, hiddenByDefault?: boolean | null }> };

export type ModuleFragment = { __typename?: 'Module', id: string, title: string, description: string, illustration: string };

export type ModuleWithCategoriesFragment = { __typename?: 'Module', id: string, title: string, description: string, illustration: string, categories?: Array<{ __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string }> | null };

export type CreateModuleMutationVariables = Exact<{
  dto: ModuleInput;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', createModule: { __typename?: 'Module', id: string, title: string, description: string, illustration: string } };

export type DeleteModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteModuleMutation = { __typename?: 'Mutation', deleteModule: boolean };

export type UpdateModuleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: ModuleInput;
}>;


export type UpdateModuleMutation = { __typename?: 'Mutation', updateModule: { __typename?: 'Module', id: string, title: string, description: string, illustration: string } };

export type GetModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesQuery = { __typename?: 'Query', modules: Array<{ __typename?: 'Module', id: string, title: string, description: string, illustration: string }> };

export type GetModulesForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesForCompanyQuery = { __typename?: 'Query', modulesForCompany: Array<{ __typename?: 'Module', id: string, title: string, description: string, illustration: string }> };

export type GetModulesWithCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesWithCategoriesQuery = { __typename?: 'Query', modulesWithCategories: Array<{ __typename?: 'Module', id: string, title: string, description: string, illustration: string, categories?: Array<{ __typename?: 'Category', id: string, title: string, description: string, illustration: string, icon: string, moduleId: string }> | null }> };

export type ProviderFragment = { __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string };

export type SearchTaskDefinitionFragment = { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string };

export type TaskDefinitionFragment = { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null };

export type TaskDefinitionSettingsFragment = { __typename?: 'TaskDefinitionSettings', companyId: string, taskDefinitionId: string, settings: any, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null };

export type CreateTaskDefinitionMutationVariables = Exact<{
  dto: CreateTaskDefinitionInput;
}>;


export type CreateTaskDefinitionMutation = { __typename?: 'Mutation', createTaskDefinition: { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null } };

export type DeleteTaskDefinitionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTaskDefinitionMutation = { __typename?: 'Mutation', deleteTaskDefinition: boolean };

export type DeleteTaskDefinitionFileMutationVariables = Exact<{
  taskDefinitionId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
}>;


export type DeleteTaskDefinitionFileMutation = { __typename?: 'Mutation', deleteTaskDefinitionFile: boolean };

export type UpdateTaskDefinitionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: UpdateTaskDefinitionInput;
}>;


export type UpdateTaskDefinitionMutation = { __typename?: 'Mutation', updateTaskDefinition: { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null } };

export type UpdateTaskDefinitionSettingsMutationVariables = Exact<{
  taskDefinitionId: Scalars['String']['input'];
  dto: TaskDefinitionSettingsInput;
}>;


export type UpdateTaskDefinitionSettingsMutation = { __typename?: 'Mutation', updateTaskDefinitionSettings: { __typename?: 'TaskDefinitionSettings', companyId: string, taskDefinitionId: string, settings: any, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null } };

export type GetTaskDefinitionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTaskDefinitionQuery = { __typename?: 'Query', taskDefinition: { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null } };

export type GetTaskDefinitionFilesQueryVariables = Exact<{
  taskDefinitionId: Scalars['String']['input'];
}>;


export type GetTaskDefinitionFilesQuery = { __typename?: 'Query', taskDefinitionFiles?: Array<{ __typename?: 'File', id: string, fileName: string, contentType?: string | null, size?: number | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null }> | null };

export type GetTaskDefinitionSettingsQueryVariables = Exact<{
  taskDefinitionId: Scalars['String']['input'];
}>;


export type GetTaskDefinitionSettingsQuery = { __typename?: 'Query', taskDefinitionSettings: { __typename?: 'TaskDefinitionSettings', companyId: string, taskDefinitionId: string, settings: any, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null } };

export type GetTaskDefinitionsQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type GetTaskDefinitionsQuery = { __typename?: 'Query', taskDefinitions: Array<{ __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null }> };

export type GetTaskDefinitionsForCompanyQueryVariables = Exact<{
  moduleId: Scalars['String']['input'];
}>;


export type GetTaskDefinitionsForCompanyQuery = { __typename?: 'Query', taskDefinitionsForCompany: Array<{ __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null }> };

export type SearchTaskDefinitionsQueryVariables = Exact<{
  options: TaskDefinitionsSearchInput;
}>;


export type SearchTaskDefinitionsQuery = { __typename?: 'Query', taskDefinitionsSearch: Array<{ __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string }> };

export type ListTaskFragment = { __typename?: 'Task', id: string, createdAt: Date, summary?: string | null, taskDefinitionLabel?: string | null, isFavorite?: boolean | null };

export type TaskFragment = { __typename?: 'Task', id: string, categoryId?: string | null, summary?: string | null, companyId: string, createdAt: Date, updatedAt: Date, userId: string, capabilityId: string, gatewayId: string, isFavorite?: boolean | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, messages?: Array<{ __typename?: 'TaskMessage', id: string, createdAt: Date, input: { __typename?: 'TaskMessageInput', formValues?: any | null, prompt?: any | null, followUpPrompt?: { __typename?: 'FollowUpPrompt', label: string, prompt: string } | null }, response?: { __typename?: 'TaskMessageResponse', text?: string | null, files?: Array<{ __typename?: 'File', id: string, fileName: string, size?: number | null, contentType?: string | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null } | null> | null, sources?: Array<{ __typename?: 'TaskMessageResponseSource', type: TaskMessageResponseSourceType, url?: string | null, title?: string | null, content?: string | null, pageNumber?: number | null, fileId?: string | null }> | null, ragDocumentReferences?: Array<{ __typename?: 'RagDocumentReference', content?: string | null, id: string, pageNumber?: number | null, relevance?: number | null, title?: string | null, url?: string | null, fileId?: string | null }> | null } | null }> | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null };

export type TaskMessageFragment = { __typename?: 'TaskMessage', id: string, createdAt: Date, input: { __typename?: 'TaskMessageInput', formValues?: any | null, prompt?: any | null, followUpPrompt?: { __typename?: 'FollowUpPrompt', label: string, prompt: string } | null }, response?: { __typename?: 'TaskMessageResponse', text?: string | null, files?: Array<{ __typename?: 'File', id: string, fileName: string, size?: number | null, contentType?: string | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null } | null> | null, sources?: Array<{ __typename?: 'TaskMessageResponseSource', type: TaskMessageResponseSourceType, url?: string | null, title?: string | null, content?: string | null, pageNumber?: number | null, fileId?: string | null }> | null, ragDocumentReferences?: Array<{ __typename?: 'RagDocumentReference', content?: string | null, id: string, pageNumber?: number | null, relevance?: number | null, title?: string | null, url?: string | null, fileId?: string | null }> | null } | null };

export type CreateTaskMutationVariables = Exact<{
  dto: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string, categoryId?: string | null, summary?: string | null, companyId: string, createdAt: Date, updatedAt: Date, userId: string, capabilityId: string, gatewayId: string, isFavorite?: boolean | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, messages?: Array<{ __typename?: 'TaskMessage', id: string, createdAt: Date, input: { __typename?: 'TaskMessageInput', formValues?: any | null, prompt?: any | null, followUpPrompt?: { __typename?: 'FollowUpPrompt', label: string, prompt: string } | null }, response?: { __typename?: 'TaskMessageResponse', text?: string | null, files?: Array<{ __typename?: 'File', id: string, fileName: string, size?: number | null, contentType?: string | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null } | null> | null, sources?: Array<{ __typename?: 'TaskMessageResponseSource', type: TaskMessageResponseSourceType, url?: string | null, title?: string | null, content?: string | null, pageNumber?: number | null, fileId?: string | null }> | null, ragDocumentReferences?: Array<{ __typename?: 'RagDocumentReference', content?: string | null, id: string, pageNumber?: number | null, relevance?: number | null, title?: string | null, url?: string | null, fileId?: string | null }> | null } | null }> | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: boolean };

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, categoryId?: string | null, summary?: string | null, companyId: string, createdAt: Date, updatedAt: Date, userId: string, capabilityId: string, gatewayId: string, isFavorite?: boolean | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, messages?: Array<{ __typename?: 'TaskMessage', id: string, createdAt: Date, input: { __typename?: 'TaskMessageInput', formValues?: any | null, prompt?: any | null, followUpPrompt?: { __typename?: 'FollowUpPrompt', label: string, prompt: string } | null }, response?: { __typename?: 'TaskMessageResponse', text?: string | null, files?: Array<{ __typename?: 'File', id: string, fileName: string, size?: number | null, contentType?: string | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null } | null> | null, sources?: Array<{ __typename?: 'TaskMessageResponseSource', type: TaskMessageResponseSourceType, url?: string | null, title?: string | null, content?: string | null, pageNumber?: number | null, fileId?: string | null }> | null, ragDocumentReferences?: Array<{ __typename?: 'RagDocumentReference', content?: string | null, id: string, pageNumber?: number | null, relevance?: number | null, title?: string | null, url?: string | null, fileId?: string | null }> | null } | null }> | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null } };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTaskQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, categoryId?: string | null, summary?: string | null, companyId: string, createdAt: Date, updatedAt: Date, userId: string, capabilityId: string, gatewayId: string, isFavorite?: boolean | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, messages?: Array<{ __typename?: 'TaskMessage', id: string, createdAt: Date, input: { __typename?: 'TaskMessageInput', formValues?: any | null, prompt?: any | null, followUpPrompt?: { __typename?: 'FollowUpPrompt', label: string, prompt: string } | null }, response?: { __typename?: 'TaskMessageResponse', text?: string | null, files?: Array<{ __typename?: 'File', id: string, fileName: string, size?: number | null, contentType?: string | null, url: string, smallUrl?: string | null, thumbnailUrl?: string | null } | null> | null, sources?: Array<{ __typename?: 'TaskMessageResponseSource', type: TaskMessageResponseSourceType, url?: string | null, title?: string | null, content?: string | null, pageNumber?: number | null, fileId?: string | null }> | null, ragDocumentReferences?: Array<{ __typename?: 'RagDocumentReference', content?: string | null, id: string, pageNumber?: number | null, relevance?: number | null, title?: string | null, url?: string | null, fileId?: string | null }> | null } | null }> | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null }, taskDefinitionForTask?: { __typename?: 'TaskDefinition', id: string, categoryId: string, moduleId: string, title: string, description: string, illustration: string, active?: boolean | null, keywords?: Array<string> | null, messageTemplate?: any | null, settingsTemplate?: any | null, capabilityId: string, isFavorite?: boolean | null, formDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, settingsFormDefinition?: Array<{ __typename?: 'FormFieldDefinition', name: string, type: string, description?: string | null, default?: any | null, minimum?: number | null, maximum?: number | null, tooltip?: string | null, label: string, required?: boolean | null, options?: Array<{ __typename?: 'FormFieldDefinitionOption', label: string, value: string }> | null }> | null, followUpPrompts?: Array<{ __typename?: 'FollowUpPrompt', label: string, prompt: string }> | null, capability?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', label: string, name: string, default?: any | null, required?: boolean | null, tooltip?: string | null, type: string, options?: Array<{ __typename?: 'TemplateFieldOption', label: string, value: string }> | null }> } | null, fileUploadInfo?: { __typename?: 'FileUploadInfo', url: string, fields: any } | null, usableProviders?: Array<{ __typename?: 'Provider', id: string, label: string, capabilityId: string, gatewayId: string }> | null } | null, capabilityForTask?: { __typename?: 'Capability', id: string, label: string, messageTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, role?: TemplateFieldRole | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }>, settingsTemplateFields: Array<{ __typename?: 'TemplateField', name: string, label: string, type: string, default?: any | null, required?: boolean | null, tooltip?: string | null, options?: Array<{ __typename?: 'TemplateFieldOption', value: string, label: string }> | null }> } | null };

export type GetTasksQueryVariables = Exact<{
  options?: InputMaybe<ListOptions>;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskList', nextToken?: string | null, items: Array<{ __typename?: 'Task', id: string, createdAt: Date, summary?: string | null, taskDefinitionLabel?: string | null, isFavorite?: boolean | null }> } };

export type UserFragment = { __typename?: 'User', id: string, createdAt: Date, companyId: string, status?: UserStatus | null, email: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, knowledgeBaseIds?: Array<string> | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type DisableUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: boolean };

export type EnableUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: boolean };

export type InviteUserMutationVariables = Exact<{
  dto: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'User', id: string, createdAt: Date, companyId: string, status?: UserStatus | null, email: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, knowledgeBaseIds?: Array<string> | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  dto: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, createdAt: Date, companyId: string, status?: UserStatus | null, email: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, knowledgeBaseIds?: Array<string> | null } };

export type GetUsersQueryVariables = Exact<{
  options?: InputMaybe<ListOptions>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserList', nextToken?: string | null, items: Array<{ __typename?: 'User', id: string, createdAt: Date, companyId: string, status?: UserStatus | null, email: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, knowledgeBaseIds?: Array<string> | null }> } };

export type OwnUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OwnUserQuery = { __typename?: 'Query', ownUser: { __typename?: 'User', id: string, createdAt: Date, companyId: string, status?: UserStatus | null, email: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, knowledgeBaseIds?: Array<string> | null } };

export const CapabilityFragmentDoc = gql`
    fragment Capability on Capability {
  id
  label
  messageTemplateFields {
    name
    label
    type
    default
    required
    options {
      value
      label
    }
    tooltip
    role
  }
  settingsTemplateFields {
    name
    label
    type
    default
    required
    options {
      value
      label
    }
    tooltip
  }
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on Company {
  id
  name
  config {
    description
    logo
    primaryColor
    primaryColorText
    secondaryColor
    primaryBrandColor
    secondaryBrandColor
    facts
    defaultGatewayId
  }
}
    `;
export const FavoriteFragmentDoc = gql`
    fragment Favorite on Favorite {
  companyId
  createdAt
  taskDefinitionId
  taskId
  userId
}
    `;
export const FavoriteListItemFragmentDoc = gql`
    fragment FavoriteListItem on FavoriteListItem {
  companyId
  createdAt
  taskDefinitionId
  taskId
  userId
  task {
    id
    isFavorite
    taskDefinitionLabel
    summary
  }
  taskDefinition {
    id
    title
    description
    illustration
    settingsFormDefinition {
      name
    }
    isFavorite
    capabilityId
    categoryId
    moduleId
  }
}
    `;
export const GatewayConfigFragmentDoc = gql`
    fragment GatewayConfig on GatewayConfig {
  companyId
  config
  gatewayId
}
    `;
export const GatewayFragmentDoc = gql`
    fragment Gateway on Gateway {
  id
  label
  configFields {
    name
    label
    type
    default
    required
    options {
      value
      label
    }
    tooltip
  }
}
    `;
export const InstanceConfigFragmentDoc = gql`
    fragment InstanceConfig on InstanceConfig {
  name
  logo
  primaryColor
  primaryColorText
  secondaryColor
  defaultGatewayId
}
    `;
export const KnowledgeBaseFragmentDoc = gql`
    fragment KnowledgeBase on KnowledgeBase {
  id
  type
  name
  accessType
  companyId
  hiddenByDefault
}
    `;
export const KnowledgeBaseDirectoryFragmentDoc = gql`
    fragment KnowledgeBaseDirectory on KnowledgeBaseDirectory {
  files {
    id
    fileName
    contentType
    size
    url
    processed
  }
  folders {
    id
    name
    path
  }
  fileUploadInfo {
    url
    fields
  }
}
    `;
export const ModuleFragmentDoc = gql`
    fragment Module on Module {
  id
  title
  description
  illustration
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  title
  description
  illustration
  icon
  moduleId
}
    `;
export const ModuleWithCategoriesFragmentDoc = gql`
    fragment ModuleWithCategories on Module {
  id
  title
  description
  illustration
  categories {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export const SearchTaskDefinitionFragmentDoc = gql`
    fragment SearchTaskDefinition on TaskDefinition {
  id
  categoryId
  moduleId
  title
  description
  illustration
}
    `;
export const ProviderFragmentDoc = gql`
    fragment Provider on Provider {
  id
  label
  capabilityId
  gatewayId
}
    `;
export const TaskDefinitionFragmentDoc = gql`
    fragment TaskDefinition on TaskDefinition {
  id
  categoryId
  moduleId
  title
  description
  illustration
  active
  keywords
  formDefinition {
    name
    type
    description
    default
    minimum
    maximum
    tooltip
    label
    options {
      label
      value
    }
    required
  }
  settingsFormDefinition {
    name
    type
    description
    default
    minimum
    maximum
    tooltip
    label
    options {
      label
      value
    }
    required
  }
  messageTemplate
  settingsTemplate
  followUpPrompts {
    label
    prompt
  }
  capabilityId
  capability {
    id
    label
    messageTemplateFields {
      label
      name
      default
      options {
        label
        value
      }
      required
      tooltip
      type
    }
    settingsTemplateFields {
      label
      name
      default
      options {
        label
        value
      }
      required
      tooltip
      type
    }
  }
  fileUploadInfo {
    url
    fields
  }
  usableProviders {
    ...Provider
  }
  isFavorite
}
    ${ProviderFragmentDoc}`;
export const TaskDefinitionSettingsFragmentDoc = gql`
    fragment TaskDefinitionSettings on TaskDefinitionSettings {
  companyId
  taskDefinitionId
  settings
  fileUploadInfo {
    url
    fields
  }
}
    `;
export const ListTaskFragmentDoc = gql`
    fragment ListTask on Task {
  id
  createdAt
  summary
  taskDefinitionLabel
  isFavorite
}
    `;
export const TaskMessageFragmentDoc = gql`
    fragment TaskMessage on TaskMessage {
  id
  createdAt
  input {
    formValues
    followUpPrompt {
      label
      prompt
    }
    prompt
  }
  response {
    files {
      id
      fileName
      size
      contentType
      url
      smallUrl
      thumbnailUrl
    }
    text
    sources {
      type
      url
      title
      content
      pageNumber
      fileId
    }
    ragDocumentReferences {
      content
      id
      pageNumber
      relevance
      title
      url
      fileId
    }
  }
}
    `;
export const TaskFragmentDoc = gql`
    fragment Task on Task {
  id
  followUpPrompts {
    label
    prompt
  }
  categoryId
  summary
  messages {
    ...TaskMessage
  }
  fileUploadInfo {
    url
    fields
  }
  companyId
  createdAt
  updatedAt
  userId
  capabilityId
  categoryId
  gatewayId
  isFavorite
}
    ${TaskMessageFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  createdAt
  companyId
  status
  email
  enabled
  firstName
  lastName
  role
  knowledgeBaseIds
}
    `;
export const GetCapabilitiesDocument = gql`
    query GetCapabilities {
  capabilities {
    ...Capability
  }
}
    ${CapabilityFragmentDoc}`;

/**
 * __useGetCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>(GetCapabilitiesDocument, options);
      }
export function useGetCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>(GetCapabilitiesDocument, options);
        }
export function useGetCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>(GetCapabilitiesDocument, options);
        }
export type GetCapabilitiesQueryHookResult = ReturnType<typeof useGetCapabilitiesQuery>;
export type GetCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetCapabilitiesLazyQuery>;
export type GetCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetCapabilitiesSuspenseQuery>;
export type GetCapabilitiesQueryResult = Apollo.QueryResult<GetCapabilitiesQuery, GetCapabilitiesQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($dto: CategoryInput!) {
  createCategory(dto: $dto) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($id: String!) {
  deleteCategory(id: $id)
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($id: String!, $dto: CategoryInput!) {
  updateCategory(id: $id, dto: $dto) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($moduleId: String!) {
  categories(moduleId: $moduleId) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($dto: CompanyInput!) {
  createCompany(dto: $dto) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($id: String!) {
  deleteCompany(id: $id)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: String!, $dto: CompanyInput!) {
  updateCompany(id: $id, dto: $dto) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetCompaniesDocument = gql`
    query GetCompanies {
  companies {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export function useGetCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetCompaniesSuspenseQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetOwnCompanyDocument = gql`
    query GetOwnCompany {
  ownCompany {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useGetOwnCompanyQuery__
 *
 * To run a query within a React component, call `useGetOwnCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>(GetOwnCompanyDocument, options);
      }
export function useGetOwnCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>(GetOwnCompanyDocument, options);
        }
export function useGetOwnCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>(GetOwnCompanyDocument, options);
        }
export type GetOwnCompanyQueryHookResult = ReturnType<typeof useGetOwnCompanyQuery>;
export type GetOwnCompanyLazyQueryHookResult = ReturnType<typeof useGetOwnCompanyLazyQuery>;
export type GetOwnCompanySuspenseQueryHookResult = ReturnType<typeof useGetOwnCompanySuspenseQuery>;
export type GetOwnCompanyQueryResult = Apollo.QueryResult<GetOwnCompanyQuery, GetOwnCompanyQueryVariables>;
export const AddFavoriteDocument = gql`
    mutation AddFavorite($dto: FavoriteInput!) {
  addFavorite(dto: $dto) {
    ...Favorite
  }
}
    ${FavoriteFragmentDoc}`;
export type AddFavoriteMutationFn = Apollo.MutationFunction<AddFavoriteMutation, AddFavoriteMutationVariables>;

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useAddFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteMutation, AddFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteMutation, AddFavoriteMutationVariables>(AddFavoriteDocument, options);
      }
export type AddFavoriteMutationHookResult = ReturnType<typeof useAddFavoriteMutation>;
export type AddFavoriteMutationResult = Apollo.MutationResult<AddFavoriteMutation>;
export type AddFavoriteMutationOptions = Apollo.BaseMutationOptions<AddFavoriteMutation, AddFavoriteMutationVariables>;
export const RemoveFavoriteDocument = gql`
    mutation RemoveFavorite($dto: FavoriteInput!) {
  removeFavorite(dto: $dto)
}
    `;
export type RemoveFavoriteMutationFn = Apollo.MutationFunction<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>;

/**
 * __useRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteMutation, { data, loading, error }] = useRemoveFavoriteMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useRemoveFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>(RemoveFavoriteDocument, options);
      }
export type RemoveFavoriteMutationHookResult = ReturnType<typeof useRemoveFavoriteMutation>;
export type RemoveFavoriteMutationResult = Apollo.MutationResult<RemoveFavoriteMutation>;
export type RemoveFavoriteMutationOptions = Apollo.BaseMutationOptions<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>;
export const GetFavoritesDocument = gql`
    query GetFavorites($options: ListOptions) {
  favorites(options: $options) {
    items {
      ...FavoriteListItem
    }
    nextToken
  }
}
    ${FavoriteListItemFragmentDoc}`;

/**
 * __useGetFavoritesQuery__
 *
 * To run a query within a React component, call `useGetFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoritesQuery, GetFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesQuery, GetFavoritesQueryVariables>(GetFavoritesDocument, options);
      }
export function useGetFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesQuery, GetFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesQuery, GetFavoritesQueryVariables>(GetFavoritesDocument, options);
        }
export function useGetFavoritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFavoritesQuery, GetFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFavoritesQuery, GetFavoritesQueryVariables>(GetFavoritesDocument, options);
        }
export type GetFavoritesQueryHookResult = ReturnType<typeof useGetFavoritesQuery>;
export type GetFavoritesLazyQueryHookResult = ReturnType<typeof useGetFavoritesLazyQuery>;
export type GetFavoritesSuspenseQueryHookResult = ReturnType<typeof useGetFavoritesSuspenseQuery>;
export type GetFavoritesQueryResult = Apollo.QueryResult<GetFavoritesQuery, GetFavoritesQueryVariables>;
export const CreateGatewayConfigDocument = gql`
    mutation CreateGatewayConfig($gatewayId: String!, $companyId: String, $dto: GatewayConfigInput!) {
  createGatewayConfig(gatewayId: $gatewayId, companyId: $companyId, dto: $dto) {
    ...GatewayConfig
  }
}
    ${GatewayConfigFragmentDoc}`;
export type CreateGatewayConfigMutationFn = Apollo.MutationFunction<CreateGatewayConfigMutation, CreateGatewayConfigMutationVariables>;

/**
 * __useCreateGatewayConfigMutation__
 *
 * To run a mutation, you first call `useCreateGatewayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGatewayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGatewayConfigMutation, { data, loading, error }] = useCreateGatewayConfigMutation({
 *   variables: {
 *      gatewayId: // value for 'gatewayId'
 *      companyId: // value for 'companyId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateGatewayConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateGatewayConfigMutation, CreateGatewayConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGatewayConfigMutation, CreateGatewayConfigMutationVariables>(CreateGatewayConfigDocument, options);
      }
export type CreateGatewayConfigMutationHookResult = ReturnType<typeof useCreateGatewayConfigMutation>;
export type CreateGatewayConfigMutationResult = Apollo.MutationResult<CreateGatewayConfigMutation>;
export type CreateGatewayConfigMutationOptions = Apollo.BaseMutationOptions<CreateGatewayConfigMutation, CreateGatewayConfigMutationVariables>;
export const DeleteGatewayConfigDocument = gql`
    mutation DeleteGatewayConfig($gatewayId: String!, $companyId: String) {
  deleteGatewayConfig(gatewayId: $gatewayId, companyId: $companyId)
}
    `;
export type DeleteGatewayConfigMutationFn = Apollo.MutationFunction<DeleteGatewayConfigMutation, DeleteGatewayConfigMutationVariables>;

/**
 * __useDeleteGatewayConfigMutation__
 *
 * To run a mutation, you first call `useDeleteGatewayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGatewayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGatewayConfigMutation, { data, loading, error }] = useDeleteGatewayConfigMutation({
 *   variables: {
 *      gatewayId: // value for 'gatewayId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteGatewayConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGatewayConfigMutation, DeleteGatewayConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGatewayConfigMutation, DeleteGatewayConfigMutationVariables>(DeleteGatewayConfigDocument, options);
      }
export type DeleteGatewayConfigMutationHookResult = ReturnType<typeof useDeleteGatewayConfigMutation>;
export type DeleteGatewayConfigMutationResult = Apollo.MutationResult<DeleteGatewayConfigMutation>;
export type DeleteGatewayConfigMutationOptions = Apollo.BaseMutationOptions<DeleteGatewayConfigMutation, DeleteGatewayConfigMutationVariables>;
export const UpdateGatewayConfigDocument = gql`
    mutation UpdateGatewayConfig($gatewayId: String!, $companyId: String, $dto: GatewayConfigInput!) {
  updateGatewayConfig(gatewayId: $gatewayId, companyId: $companyId, dto: $dto) {
    ...GatewayConfig
  }
}
    ${GatewayConfigFragmentDoc}`;
export type UpdateGatewayConfigMutationFn = Apollo.MutationFunction<UpdateGatewayConfigMutation, UpdateGatewayConfigMutationVariables>;

/**
 * __useUpdateGatewayConfigMutation__
 *
 * To run a mutation, you first call `useUpdateGatewayConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGatewayConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGatewayConfigMutation, { data, loading, error }] = useUpdateGatewayConfigMutation({
 *   variables: {
 *      gatewayId: // value for 'gatewayId'
 *      companyId: // value for 'companyId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateGatewayConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGatewayConfigMutation, UpdateGatewayConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGatewayConfigMutation, UpdateGatewayConfigMutationVariables>(UpdateGatewayConfigDocument, options);
      }
export type UpdateGatewayConfigMutationHookResult = ReturnType<typeof useUpdateGatewayConfigMutation>;
export type UpdateGatewayConfigMutationResult = Apollo.MutationResult<UpdateGatewayConfigMutation>;
export type UpdateGatewayConfigMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayConfigMutation, UpdateGatewayConfigMutationVariables>;
export const GetGatewayConfigsDocument = gql`
    query GetGatewayConfigs($companyId: String) {
  gatewayConfigs(companyId: $companyId) {
    ...GatewayConfig
  }
}
    ${GatewayConfigFragmentDoc}`;

/**
 * __useGetGatewayConfigsQuery__
 *
 * To run a query within a React component, call `useGetGatewayConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGatewayConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGatewayConfigsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGatewayConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>(GetGatewayConfigsDocument, options);
      }
export function useGetGatewayConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>(GetGatewayConfigsDocument, options);
        }
export function useGetGatewayConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>(GetGatewayConfigsDocument, options);
        }
export type GetGatewayConfigsQueryHookResult = ReturnType<typeof useGetGatewayConfigsQuery>;
export type GetGatewayConfigsLazyQueryHookResult = ReturnType<typeof useGetGatewayConfigsLazyQuery>;
export type GetGatewayConfigsSuspenseQueryHookResult = ReturnType<typeof useGetGatewayConfigsSuspenseQuery>;
export type GetGatewayConfigsQueryResult = Apollo.QueryResult<GetGatewayConfigsQuery, GetGatewayConfigsQueryVariables>;
export const GetGatewaysDocument = gql`
    query GetGateways {
  gateways {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;

/**
 * __useGetGatewaysQuery__
 *
 * To run a query within a React component, call `useGetGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGatewaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGatewaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGatewaysQuery(baseOptions?: Apollo.QueryHookOptions<GetGatewaysQuery, GetGatewaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGatewaysQuery, GetGatewaysQueryVariables>(GetGatewaysDocument, options);
      }
export function useGetGatewaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGatewaysQuery, GetGatewaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGatewaysQuery, GetGatewaysQueryVariables>(GetGatewaysDocument, options);
        }
export function useGetGatewaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGatewaysQuery, GetGatewaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGatewaysQuery, GetGatewaysQueryVariables>(GetGatewaysDocument, options);
        }
export type GetGatewaysQueryHookResult = ReturnType<typeof useGetGatewaysQuery>;
export type GetGatewaysLazyQueryHookResult = ReturnType<typeof useGetGatewaysLazyQuery>;
export type GetGatewaysSuspenseQueryHookResult = ReturnType<typeof useGetGatewaysSuspenseQuery>;
export type GetGatewaysQueryResult = Apollo.QueryResult<GetGatewaysQuery, GetGatewaysQueryVariables>;
export const SetInstanceConfigDocument = gql`
    mutation setInstanceConfig($config: InstanceConfigInput!) {
  setInstanceConfig(config: $config) {
    ...InstanceConfig
  }
}
    ${InstanceConfigFragmentDoc}`;
export type SetInstanceConfigMutationFn = Apollo.MutationFunction<SetInstanceConfigMutation, SetInstanceConfigMutationVariables>;

/**
 * __useSetInstanceConfigMutation__
 *
 * To run a mutation, you first call `useSetInstanceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInstanceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInstanceConfigMutation, { data, loading, error }] = useSetInstanceConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSetInstanceConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetInstanceConfigMutation, SetInstanceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInstanceConfigMutation, SetInstanceConfigMutationVariables>(SetInstanceConfigDocument, options);
      }
export type SetInstanceConfigMutationHookResult = ReturnType<typeof useSetInstanceConfigMutation>;
export type SetInstanceConfigMutationResult = Apollo.MutationResult<SetInstanceConfigMutation>;
export type SetInstanceConfigMutationOptions = Apollo.BaseMutationOptions<SetInstanceConfigMutation, SetInstanceConfigMutationVariables>;
export const GetInstanceConfigDocument = gql`
    query GetInstanceConfig {
  instanceConfig {
    ...InstanceConfig
  }
}
    ${InstanceConfigFragmentDoc}`;

/**
 * __useGetInstanceConfigQuery__
 *
 * To run a query within a React component, call `useGetInstanceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstanceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstanceConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstanceConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>(GetInstanceConfigDocument, options);
      }
export function useGetInstanceConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>(GetInstanceConfigDocument, options);
        }
export function useGetInstanceConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>(GetInstanceConfigDocument, options);
        }
export type GetInstanceConfigQueryHookResult = ReturnType<typeof useGetInstanceConfigQuery>;
export type GetInstanceConfigLazyQueryHookResult = ReturnType<typeof useGetInstanceConfigLazyQuery>;
export type GetInstanceConfigSuspenseQueryHookResult = ReturnType<typeof useGetInstanceConfigSuspenseQuery>;
export type GetInstanceConfigQueryResult = Apollo.QueryResult<GetInstanceConfigQuery, GetInstanceConfigQueryVariables>;
export const CreateKnowledgeBaseDocument = gql`
    mutation createKnowledgeBase($dto: KnowledgeBaseInput!) {
  createKnowledgeBase(dto: $dto) {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;
export type CreateKnowledgeBaseMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;

/**
 * __useCreateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseMutation, { data, loading, error }] = useCreateKnowledgeBaseMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>(CreateKnowledgeBaseDocument, options);
      }
export type CreateKnowledgeBaseMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationResult = Apollo.MutationResult<CreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;
export const CreateKnowledgeBaseFolderDocument = gql`
    mutation createKnowledgeBaseFolder($knowledgeBaseId: String!, $path: String, $name: String!) {
  createKnowledgeBaseFolder(
    knowledgeBaseId: $knowledgeBaseId
    path: $path
    name: $name
  )
}
    `;
export type CreateKnowledgeBaseFolderMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>;

/**
 * __useCreateKnowledgeBaseFolderMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseFolderMutation, { data, loading, error }] = useCreateKnowledgeBaseFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      path: // value for 'path'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateKnowledgeBaseFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>(CreateKnowledgeBaseFolderDocument, options);
      }
export type CreateKnowledgeBaseFolderMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseFolderMutation>;
export type CreateKnowledgeBaseFolderMutationResult = Apollo.MutationResult<CreateKnowledgeBaseFolderMutation>;
export type CreateKnowledgeBaseFolderMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>;
export const DeleteKnowledgeBaseDocument = gql`
    mutation deleteKnowledgeBase($id: String!) {
  deleteKnowledgeBase(id: $id)
}
    `;
export type DeleteKnowledgeBaseMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;

/**
 * __useDeleteKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseMutation, { data, loading, error }] = useDeleteKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>(DeleteKnowledgeBaseDocument, options);
      }
export type DeleteKnowledgeBaseMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;
export const DeleteKnowledgeBaseFileDocument = gql`
    mutation deleteKnowledgeBaseFile($knowledgeBaseId: String!, $id: String!) {
  deleteKnowledgeBaseFile(knowledgeBaseId: $knowledgeBaseId, id: $id)
}
    `;
export type DeleteKnowledgeBaseFileMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseFileMutation, DeleteKnowledgeBaseFileMutationVariables>;

/**
 * __useDeleteKnowledgeBaseFileMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseFileMutation, { data, loading, error }] = useDeleteKnowledgeBaseFileMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseFileMutation, DeleteKnowledgeBaseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseFileMutation, DeleteKnowledgeBaseFileMutationVariables>(DeleteKnowledgeBaseFileDocument, options);
      }
export type DeleteKnowledgeBaseFileMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseFileMutation>;
export type DeleteKnowledgeBaseFileMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseFileMutation>;
export type DeleteKnowledgeBaseFileMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseFileMutation, DeleteKnowledgeBaseFileMutationVariables>;
export const UpdateKnowledgeBaseDocument = gql`
    mutation updateKnowledgeBase($id: String!, $dto: KnowledgeBaseInput!) {
  updateKnowledgeBase(id: $id, dto: $dto) {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;
export type UpdateKnowledgeBaseMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;

/**
 * __useUpdateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseMutation, { data, loading, error }] = useUpdateKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>(UpdateKnowledgeBaseDocument, options);
      }
export type UpdateKnowledgeBaseMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;
export const KnowledgeBaseDocument = gql`
    query knowledgeBase($id: String!) {
  knowledgeBase(id: $id) {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;

/**
 * __useKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKnowledgeBaseQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables> & ({ variables: KnowledgeBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
      }
export function useKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
        }
export function useKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
        }
export type KnowledgeBaseQueryHookResult = ReturnType<typeof useKnowledgeBaseQuery>;
export type KnowledgeBaseLazyQueryHookResult = ReturnType<typeof useKnowledgeBaseLazyQuery>;
export type KnowledgeBaseSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBaseSuspenseQuery>;
export type KnowledgeBaseQueryResult = Apollo.QueryResult<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>;
export const KnowledgeBaseDirectoryDocument = gql`
    query knowledgeBaseDirectory($knowledgeBaseId: String!, $path: String) {
  knowledgeBase(id: $knowledgeBaseId) {
    ...KnowledgeBase
  }
  knowledgeBaseDirectory(knowledgeBaseId: $knowledgeBaseId, path: $path) {
    ...KnowledgeBaseDirectory
  }
}
    ${KnowledgeBaseFragmentDoc}
${KnowledgeBaseDirectoryFragmentDoc}`;

/**
 * __useKnowledgeBaseDirectoryQuery__
 *
 * To run a query within a React component, call `useKnowledgeBaseDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseDirectoryQuery({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useKnowledgeBaseDirectoryQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables> & ({ variables: KnowledgeBaseDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>(KnowledgeBaseDirectoryDocument, options);
      }
export function useKnowledgeBaseDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>(KnowledgeBaseDirectoryDocument, options);
        }
export function useKnowledgeBaseDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>(KnowledgeBaseDirectoryDocument, options);
        }
export type KnowledgeBaseDirectoryQueryHookResult = ReturnType<typeof useKnowledgeBaseDirectoryQuery>;
export type KnowledgeBaseDirectoryLazyQueryHookResult = ReturnType<typeof useKnowledgeBaseDirectoryLazyQuery>;
export type KnowledgeBaseDirectorySuspenseQueryHookResult = ReturnType<typeof useKnowledgeBaseDirectorySuspenseQuery>;
export type KnowledgeBaseDirectoryQueryResult = Apollo.QueryResult<KnowledgeBaseDirectoryQuery, KnowledgeBaseDirectoryQueryVariables>;
export const KnowledgeBasesDocument = gql`
    query knowledgeBases {
  knowledgeBases {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;

/**
 * __useKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useKnowledgeBasesQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>(KnowledgeBasesDocument, options);
      }
export function useKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>(KnowledgeBasesDocument, options);
        }
export function useKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>(KnowledgeBasesDocument, options);
        }
export type KnowledgeBasesQueryHookResult = ReturnType<typeof useKnowledgeBasesQuery>;
export type KnowledgeBasesLazyQueryHookResult = ReturnType<typeof useKnowledgeBasesLazyQuery>;
export type KnowledgeBasesSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBasesSuspenseQuery>;
export type KnowledgeBasesQueryResult = Apollo.QueryResult<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>;
export const MyKnowledgeBasesDocument = gql`
    query myKnowledgeBases {
  myKnowledgeBases {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;

/**
 * __useMyKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useMyKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyKnowledgeBasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyKnowledgeBasesQuery(baseOptions?: Apollo.QueryHookOptions<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>(MyKnowledgeBasesDocument, options);
      }
export function useMyKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>(MyKnowledgeBasesDocument, options);
        }
export function useMyKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>(MyKnowledgeBasesDocument, options);
        }
export type MyKnowledgeBasesQueryHookResult = ReturnType<typeof useMyKnowledgeBasesQuery>;
export type MyKnowledgeBasesLazyQueryHookResult = ReturnType<typeof useMyKnowledgeBasesLazyQuery>;
export type MyKnowledgeBasesSuspenseQueryHookResult = ReturnType<typeof useMyKnowledgeBasesSuspenseQuery>;
export type MyKnowledgeBasesQueryResult = Apollo.QueryResult<MyKnowledgeBasesQuery, MyKnowledgeBasesQueryVariables>;
export const CreateModuleDocument = gql`
    mutation CreateModule($dto: ModuleInput!) {
  createModule(dto: $dto) {
    ...Module
  }
}
    ${ModuleFragmentDoc}`;
export type CreateModuleMutationFn = Apollo.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, options);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = Apollo.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const DeleteModuleDocument = gql`
    mutation DeleteModule($id: String!) {
  deleteModule(id: $id)
}
    `;
export type DeleteModuleMutationFn = Apollo.MutationFunction<DeleteModuleMutation, DeleteModuleMutationVariables>;

/**
 * __useDeleteModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleMutation, { data, loading, error }] = useDeleteModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleMutation, DeleteModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleMutation, DeleteModuleMutationVariables>(DeleteModuleDocument, options);
      }
export type DeleteModuleMutationHookResult = ReturnType<typeof useDeleteModuleMutation>;
export type DeleteModuleMutationResult = Apollo.MutationResult<DeleteModuleMutation>;
export type DeleteModuleMutationOptions = Apollo.BaseMutationOptions<DeleteModuleMutation, DeleteModuleMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation UpdateModule($id: String!, $dto: ModuleInput!) {
  updateModule(id: $id, dto: $dto) {
    ...Module
  }
}
    ${ModuleFragmentDoc}`;
export type UpdateModuleMutationFn = Apollo.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, options);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = Apollo.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = Apollo.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const GetModulesDocument = gql`
    query GetModules {
  modules {
    ...Module
  }
}
    ${ModuleFragmentDoc}`;

/**
 * __useGetModulesQuery__
 *
 * To run a query within a React component, call `useGetModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
      }
export function useGetModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
export type GetModulesQueryHookResult = ReturnType<typeof useGetModulesQuery>;
export type GetModulesLazyQueryHookResult = ReturnType<typeof useGetModulesLazyQuery>;
export type GetModulesSuspenseQueryHookResult = ReturnType<typeof useGetModulesSuspenseQuery>;
export type GetModulesQueryResult = Apollo.QueryResult<GetModulesQuery, GetModulesQueryVariables>;
export const GetModulesForCompanyDocument = gql`
    query GetModulesForCompany {
  modulesForCompany {
    ...Module
  }
}
    ${ModuleFragmentDoc}`;

/**
 * __useGetModulesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetModulesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesForCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>(GetModulesForCompanyDocument, options);
      }
export function useGetModulesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>(GetModulesForCompanyDocument, options);
        }
export function useGetModulesForCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>(GetModulesForCompanyDocument, options);
        }
export type GetModulesForCompanyQueryHookResult = ReturnType<typeof useGetModulesForCompanyQuery>;
export type GetModulesForCompanyLazyQueryHookResult = ReturnType<typeof useGetModulesForCompanyLazyQuery>;
export type GetModulesForCompanySuspenseQueryHookResult = ReturnType<typeof useGetModulesForCompanySuspenseQuery>;
export type GetModulesForCompanyQueryResult = Apollo.QueryResult<GetModulesForCompanyQuery, GetModulesForCompanyQueryVariables>;
export const GetModulesWithCategoriesDocument = gql`
    query GetModulesWithCategories {
  modulesWithCategories {
    ...ModuleWithCategories
  }
}
    ${ModuleWithCategoriesFragmentDoc}`;

/**
 * __useGetModulesWithCategoriesQuery__
 *
 * To run a query within a React component, call `useGetModulesWithCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesWithCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesWithCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesWithCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>(GetModulesWithCategoriesDocument, options);
      }
export function useGetModulesWithCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>(GetModulesWithCategoriesDocument, options);
        }
export function useGetModulesWithCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>(GetModulesWithCategoriesDocument, options);
        }
export type GetModulesWithCategoriesQueryHookResult = ReturnType<typeof useGetModulesWithCategoriesQuery>;
export type GetModulesWithCategoriesLazyQueryHookResult = ReturnType<typeof useGetModulesWithCategoriesLazyQuery>;
export type GetModulesWithCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetModulesWithCategoriesSuspenseQuery>;
export type GetModulesWithCategoriesQueryResult = Apollo.QueryResult<GetModulesWithCategoriesQuery, GetModulesWithCategoriesQueryVariables>;
export const CreateTaskDefinitionDocument = gql`
    mutation CreateTaskDefinition($dto: CreateTaskDefinitionInput!) {
  createTaskDefinition(dto: $dto) {
    ...TaskDefinition
  }
}
    ${TaskDefinitionFragmentDoc}`;
export type CreateTaskDefinitionMutationFn = Apollo.MutationFunction<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;

/**
 * __useCreateTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskDefinitionMutation, { data, loading, error }] = useCreateTaskDefinitionMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>(CreateTaskDefinitionDocument, options);
      }
export type CreateTaskDefinitionMutationHookResult = ReturnType<typeof useCreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationResult = Apollo.MutationResult<CreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;
export const DeleteTaskDefinitionDocument = gql`
    mutation DeleteTaskDefinition($id: String!) {
  deleteTaskDefinition(id: $id)
}
    `;
export type DeleteTaskDefinitionMutationFn = Apollo.MutationFunction<DeleteTaskDefinitionMutation, DeleteTaskDefinitionMutationVariables>;

/**
 * __useDeleteTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskDefinitionMutation, { data, loading, error }] = useDeleteTaskDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskDefinitionMutation, DeleteTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskDefinitionMutation, DeleteTaskDefinitionMutationVariables>(DeleteTaskDefinitionDocument, options);
      }
export type DeleteTaskDefinitionMutationHookResult = ReturnType<typeof useDeleteTaskDefinitionMutation>;
export type DeleteTaskDefinitionMutationResult = Apollo.MutationResult<DeleteTaskDefinitionMutation>;
export type DeleteTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteTaskDefinitionMutation, DeleteTaskDefinitionMutationVariables>;
export const DeleteTaskDefinitionFileDocument = gql`
    mutation DeleteTaskDefinitionFile($taskDefinitionId: String!, $fileId: String!) {
  deleteTaskDefinitionFile(taskDefinitionId: $taskDefinitionId, fileId: $fileId)
}
    `;
export type DeleteTaskDefinitionFileMutationFn = Apollo.MutationFunction<DeleteTaskDefinitionFileMutation, DeleteTaskDefinitionFileMutationVariables>;

/**
 * __useDeleteTaskDefinitionFileMutation__
 *
 * To run a mutation, you first call `useDeleteTaskDefinitionFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskDefinitionFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskDefinitionFileMutation, { data, loading, error }] = useDeleteTaskDefinitionFileMutation({
 *   variables: {
 *      taskDefinitionId: // value for 'taskDefinitionId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteTaskDefinitionFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskDefinitionFileMutation, DeleteTaskDefinitionFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskDefinitionFileMutation, DeleteTaskDefinitionFileMutationVariables>(DeleteTaskDefinitionFileDocument, options);
      }
export type DeleteTaskDefinitionFileMutationHookResult = ReturnType<typeof useDeleteTaskDefinitionFileMutation>;
export type DeleteTaskDefinitionFileMutationResult = Apollo.MutationResult<DeleteTaskDefinitionFileMutation>;
export type DeleteTaskDefinitionFileMutationOptions = Apollo.BaseMutationOptions<DeleteTaskDefinitionFileMutation, DeleteTaskDefinitionFileMutationVariables>;
export const UpdateTaskDefinitionDocument = gql`
    mutation UpdateTaskDefinition($id: String!, $dto: UpdateTaskDefinitionInput!) {
  updateTaskDefinition(id: $id, dto: $dto) {
    ...TaskDefinition
  }
}
    ${TaskDefinitionFragmentDoc}`;
export type UpdateTaskDefinitionMutationFn = Apollo.MutationFunction<UpdateTaskDefinitionMutation, UpdateTaskDefinitionMutationVariables>;

/**
 * __useUpdateTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDefinitionMutation, { data, loading, error }] = useUpdateTaskDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDefinitionMutation, UpdateTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDefinitionMutation, UpdateTaskDefinitionMutationVariables>(UpdateTaskDefinitionDocument, options);
      }
export type UpdateTaskDefinitionMutationHookResult = ReturnType<typeof useUpdateTaskDefinitionMutation>;
export type UpdateTaskDefinitionMutationResult = Apollo.MutationResult<UpdateTaskDefinitionMutation>;
export type UpdateTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDefinitionMutation, UpdateTaskDefinitionMutationVariables>;
export const UpdateTaskDefinitionSettingsDocument = gql`
    mutation updateTaskDefinitionSettings($taskDefinitionId: String!, $dto: TaskDefinitionSettingsInput!) {
  updateTaskDefinitionSettings(taskDefinitionId: $taskDefinitionId, dto: $dto) {
    ...TaskDefinitionSettings
  }
}
    ${TaskDefinitionSettingsFragmentDoc}`;
export type UpdateTaskDefinitionSettingsMutationFn = Apollo.MutationFunction<UpdateTaskDefinitionSettingsMutation, UpdateTaskDefinitionSettingsMutationVariables>;

/**
 * __useUpdateTaskDefinitionSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDefinitionSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDefinitionSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDefinitionSettingsMutation, { data, loading, error }] = useUpdateTaskDefinitionSettingsMutation({
 *   variables: {
 *      taskDefinitionId: // value for 'taskDefinitionId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTaskDefinitionSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDefinitionSettingsMutation, UpdateTaskDefinitionSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDefinitionSettingsMutation, UpdateTaskDefinitionSettingsMutationVariables>(UpdateTaskDefinitionSettingsDocument, options);
      }
export type UpdateTaskDefinitionSettingsMutationHookResult = ReturnType<typeof useUpdateTaskDefinitionSettingsMutation>;
export type UpdateTaskDefinitionSettingsMutationResult = Apollo.MutationResult<UpdateTaskDefinitionSettingsMutation>;
export type UpdateTaskDefinitionSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDefinitionSettingsMutation, UpdateTaskDefinitionSettingsMutationVariables>;
export const GetTaskDefinitionDocument = gql`
    query GetTaskDefinition($id: String!) {
  taskDefinition(id: $id) {
    ...TaskDefinition
  }
}
    ${TaskDefinitionFragmentDoc}`;

/**
 * __useGetTaskDefinitionQuery__
 *
 * To run a query within a React component, call `useGetTaskDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables> & ({ variables: GetTaskDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>(GetTaskDefinitionDocument, options);
      }
export function useGetTaskDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>(GetTaskDefinitionDocument, options);
        }
export function useGetTaskDefinitionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>(GetTaskDefinitionDocument, options);
        }
export type GetTaskDefinitionQueryHookResult = ReturnType<typeof useGetTaskDefinitionQuery>;
export type GetTaskDefinitionLazyQueryHookResult = ReturnType<typeof useGetTaskDefinitionLazyQuery>;
export type GetTaskDefinitionSuspenseQueryHookResult = ReturnType<typeof useGetTaskDefinitionSuspenseQuery>;
export type GetTaskDefinitionQueryResult = Apollo.QueryResult<GetTaskDefinitionQuery, GetTaskDefinitionQueryVariables>;
export const GetTaskDefinitionFilesDocument = gql`
    query GetTaskDefinitionFiles($taskDefinitionId: String!) {
  taskDefinitionFiles(taskDefinitionId: $taskDefinitionId) {
    id
    fileName
    contentType
    size
    url
    smallUrl
    thumbnailUrl
  }
}
    `;

/**
 * __useGetTaskDefinitionFilesQuery__
 *
 * To run a query within a React component, call `useGetTaskDefinitionFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDefinitionFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDefinitionFilesQuery({
 *   variables: {
 *      taskDefinitionId: // value for 'taskDefinitionId'
 *   },
 * });
 */
export function useGetTaskDefinitionFilesQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables> & ({ variables: GetTaskDefinitionFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>(GetTaskDefinitionFilesDocument, options);
      }
export function useGetTaskDefinitionFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>(GetTaskDefinitionFilesDocument, options);
        }
export function useGetTaskDefinitionFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>(GetTaskDefinitionFilesDocument, options);
        }
export type GetTaskDefinitionFilesQueryHookResult = ReturnType<typeof useGetTaskDefinitionFilesQuery>;
export type GetTaskDefinitionFilesLazyQueryHookResult = ReturnType<typeof useGetTaskDefinitionFilesLazyQuery>;
export type GetTaskDefinitionFilesSuspenseQueryHookResult = ReturnType<typeof useGetTaskDefinitionFilesSuspenseQuery>;
export type GetTaskDefinitionFilesQueryResult = Apollo.QueryResult<GetTaskDefinitionFilesQuery, GetTaskDefinitionFilesQueryVariables>;
export const GetTaskDefinitionSettingsDocument = gql`
    query GetTaskDefinitionSettings($taskDefinitionId: String!) {
  taskDefinitionSettings(taskDefinitionId: $taskDefinitionId) {
    ...TaskDefinitionSettings
  }
}
    ${TaskDefinitionSettingsFragmentDoc}`;

/**
 * __useGetTaskDefinitionSettingsQuery__
 *
 * To run a query within a React component, call `useGetTaskDefinitionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDefinitionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDefinitionSettingsQuery({
 *   variables: {
 *      taskDefinitionId: // value for 'taskDefinitionId'
 *   },
 * });
 */
export function useGetTaskDefinitionSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables> & ({ variables: GetTaskDefinitionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>(GetTaskDefinitionSettingsDocument, options);
      }
export function useGetTaskDefinitionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>(GetTaskDefinitionSettingsDocument, options);
        }
export function useGetTaskDefinitionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>(GetTaskDefinitionSettingsDocument, options);
        }
export type GetTaskDefinitionSettingsQueryHookResult = ReturnType<typeof useGetTaskDefinitionSettingsQuery>;
export type GetTaskDefinitionSettingsLazyQueryHookResult = ReturnType<typeof useGetTaskDefinitionSettingsLazyQuery>;
export type GetTaskDefinitionSettingsSuspenseQueryHookResult = ReturnType<typeof useGetTaskDefinitionSettingsSuspenseQuery>;
export type GetTaskDefinitionSettingsQueryResult = Apollo.QueryResult<GetTaskDefinitionSettingsQuery, GetTaskDefinitionSettingsQueryVariables>;
export const GetTaskDefinitionsDocument = gql`
    query GetTaskDefinitions($categoryId: String!) {
  taskDefinitions(categoryId: $categoryId) {
    ...TaskDefinition
  }
}
    ${TaskDefinitionFragmentDoc}`;

/**
 * __useGetTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDefinitionsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetTaskDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables> & ({ variables: GetTaskDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>(GetTaskDefinitionsDocument, options);
      }
export function useGetTaskDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>(GetTaskDefinitionsDocument, options);
        }
export function useGetTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>(GetTaskDefinitionsDocument, options);
        }
export type GetTaskDefinitionsQueryHookResult = ReturnType<typeof useGetTaskDefinitionsQuery>;
export type GetTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useGetTaskDefinitionsLazyQuery>;
export type GetTaskDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetTaskDefinitionsSuspenseQuery>;
export type GetTaskDefinitionsQueryResult = Apollo.QueryResult<GetTaskDefinitionsQuery, GetTaskDefinitionsQueryVariables>;
export const GetTaskDefinitionsForCompanyDocument = gql`
    query GetTaskDefinitionsForCompany($moduleId: String!) {
  taskDefinitionsForCompany(moduleId: $moduleId) {
    ...TaskDefinition
  }
}
    ${TaskDefinitionFragmentDoc}`;

/**
 * __useGetTaskDefinitionsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetTaskDefinitionsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDefinitionsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDefinitionsForCompanyQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetTaskDefinitionsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables> & ({ variables: GetTaskDefinitionsForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>(GetTaskDefinitionsForCompanyDocument, options);
      }
export function useGetTaskDefinitionsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>(GetTaskDefinitionsForCompanyDocument, options);
        }
export function useGetTaskDefinitionsForCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>(GetTaskDefinitionsForCompanyDocument, options);
        }
export type GetTaskDefinitionsForCompanyQueryHookResult = ReturnType<typeof useGetTaskDefinitionsForCompanyQuery>;
export type GetTaskDefinitionsForCompanyLazyQueryHookResult = ReturnType<typeof useGetTaskDefinitionsForCompanyLazyQuery>;
export type GetTaskDefinitionsForCompanySuspenseQueryHookResult = ReturnType<typeof useGetTaskDefinitionsForCompanySuspenseQuery>;
export type GetTaskDefinitionsForCompanyQueryResult = Apollo.QueryResult<GetTaskDefinitionsForCompanyQuery, GetTaskDefinitionsForCompanyQueryVariables>;
export const SearchTaskDefinitionsDocument = gql`
    query SearchTaskDefinitions($options: TaskDefinitionsSearchInput!) {
  taskDefinitionsSearch(options: $options) {
    ...SearchTaskDefinition
  }
}
    ${SearchTaskDefinitionFragmentDoc}`;

/**
 * __useSearchTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useSearchTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTaskDefinitionsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchTaskDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables> & ({ variables: SearchTaskDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>(SearchTaskDefinitionsDocument, options);
      }
export function useSearchTaskDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>(SearchTaskDefinitionsDocument, options);
        }
export function useSearchTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>(SearchTaskDefinitionsDocument, options);
        }
export type SearchTaskDefinitionsQueryHookResult = ReturnType<typeof useSearchTaskDefinitionsQuery>;
export type SearchTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useSearchTaskDefinitionsLazyQuery>;
export type SearchTaskDefinitionsSuspenseQueryHookResult = ReturnType<typeof useSearchTaskDefinitionsSuspenseQuery>;
export type SearchTaskDefinitionsQueryResult = Apollo.QueryResult<SearchTaskDefinitionsQuery, SearchTaskDefinitionsQueryVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($dto: CreateTaskInput!) {
  createTask(dto: $dto) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: String!) {
  deleteTask(id: $id)
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($id: String!, $dto: UpdateTaskInput!) {
  updateTask(id: $id, dto: $dto) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($id: String!) {
  task(id: $id) {
    ...Task
  }
  taskDefinitionForTask(taskId: $id) {
    ...TaskDefinition
  }
  capabilityForTask(taskId: $id) {
    ...Capability
  }
}
    ${TaskFragmentDoc}
${TaskDefinitionFragmentDoc}
${CapabilityFragmentDoc}`;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export function useGetTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetTasksDocument = gql`
    query GetTasks($options: ListOptions) {
  tasks(options: $options) {
    items {
      ...ListTask
    }
    nextToken
  }
}
    ${ListTaskFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: String!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DisableUserDocument = gql`
    mutation DisableUser($id: String!) {
  disableUser(id: $id)
}
    `;
export type DisableUserMutationFn = Apollo.MutationFunction<DisableUserMutation, DisableUserMutationVariables>;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const EnableUserDocument = gql`
    mutation EnableUser($id: String!) {
  enableUser(id: $id)
}
    `;
export type EnableUserMutationFn = Apollo.MutationFunction<EnableUserMutation, EnableUserMutationVariables>;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUserMutation, { data, loading, error }] = useEnableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableUserMutation, EnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
      }
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<EnableUserMutation, EnableUserMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($dto: InviteUserInput!) {
  inviteUser(dto: $dto) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $dto: UpdateUserInput!) {
  updateUser(id: $id, dto: $dto) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($options: ListOptions) {
  users(options: $options) {
    items {
      ...User
    }
    nextToken
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const OwnUserDocument = gql`
    query OwnUser {
  ownUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useOwnUserQuery__
 *
 * To run a query within a React component, call `useOwnUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOwnUserQuery(baseOptions?: Apollo.QueryHookOptions<OwnUserQuery, OwnUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnUserQuery, OwnUserQueryVariables>(OwnUserDocument, options);
      }
export function useOwnUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnUserQuery, OwnUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnUserQuery, OwnUserQueryVariables>(OwnUserDocument, options);
        }
export function useOwnUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OwnUserQuery, OwnUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnUserQuery, OwnUserQueryVariables>(OwnUserDocument, options);
        }
export type OwnUserQueryHookResult = ReturnType<typeof useOwnUserQuery>;
export type OwnUserLazyQueryHookResult = ReturnType<typeof useOwnUserLazyQuery>;
export type OwnUserSuspenseQueryHookResult = ReturnType<typeof useOwnUserSuspenseQuery>;
export type OwnUserQueryResult = Apollo.QueryResult<OwnUserQuery, OwnUserQueryVariables>;